import { Drone } from '@/types/utm/drone.types';

import { UTM_URL, utmApi } from './utm.api';

export const droneApi = utmApi.injectEndpoints({
  endpoints: (builder) => ({
    createDrone: builder.mutation<Drone, Partial<Drone>>({
      query: (drone: Drone) => ({
        url: `${UTM_URL}/drones`,
        method: 'POST',
        body: drone,
      }),
    }),
    updateDrone: builder.mutation<Drone, Drone>({
      query: (drone) => ({
        url: `${UTM_URL}/drones/${drone.id}`,
        method: 'PUT',
        body: drone,
      }),
    }),
    deleteDrone: builder.mutation<void, number>({
      query: (id) => ({
        url: `${UTM_URL}/drones/${id}`,
        method: 'DELETE',
      }),
    }),
    getDroneByCode: builder.query<Drone | null, { code: string; site: string }>({
      query: ({ code, site }) => ({
        url: `${UTM_URL}/drones/${site}/${code}`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetDroneByCodeQuery, useDeleteDroneMutation, useCreateDroneMutation, useUpdateDroneMutation } =
  droneApi;
